export const calculateRowHeight = (params: any): number => {
    const { model } = params;
    
    // Get content lengths for text-heavy fields
    const notesLength = (model.notes || '').length;
    const destCitiesLength = (model.destinationCities || '').length;
    
    // Find the maximum content length among text fields
    const maxContentLength = Math.max(
        notesLength, 
        destCitiesLength, 
    ); 
    
    // Calculate height based on content length
    if (maxContentLength > 400) return 200;      // Very long text
    if (maxContentLength > 250) return 150;      // Long text
    if (maxContentLength > 200) return 100;      // Medium-long text
    if (maxContentLength > 100) return 80;       // Medium text
    if (maxContentLength > 50) return 70;        // Short-medium text
    return 60;                                   // Default minimum height
};